var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locations-Feature",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "location-dot",
    transform: "translate(3.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.02979687,0 0,4.02979884 0,9.00005127 C0,12.6285062 1.26417187,13.6421785 8.07567187,23.516074 C8.52248437,24.1613087 9.4775625,24.1613087 9.92432812,23.516074 C16.7358281,13.6421785 18,12.6285062 18,9.00005127 C18,4.02979884 13.9702031,0 9,0 Z M9,12.7499125 C6.93164062,12.7499125 5.25,11.068271 5.25,8.99991064 C5.25,6.93155026 6.93164062,5.24986194 9,5.24986194 C11.0683594,5.24986194 12.75,6.93150338 12.75,8.99991064 C12.75,11.0683179 11.0683594,12.7499125 9,12.7499125 Z",
    id: "Shape",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,9.00002083 C11,10.104551 10.1045833,11 9,11 C7.89541667,11 7,10.104551 7,9.00002083 C7,7.89549067 7.89541667,7 9,7 C10.1045833,7 11,7.89544901 11,9.00002083 Z",
    id: "Path",
    fill: "#4C69BA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.6c0c586f.svg";
export { ForwardRef as ReactComponent };